import React from 'react';
import { useState, useEffect } from 'react';
import { Link, useHistory } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import CustomTittle from '../../../components/Elements/customTittle/customTittle';
import ChooseUserOption from './chooseUserOption/chooseUserOption';
import ChooseUserSelect from './chooseUserSelect/chooseUserSelect';
import CustomButtons from '../../../components/Elements/Buttons/customButton';
import CourseDetail from '../../coursDetail/courseDetail';
import { API_URL } from '../../../config';
import axios from 'axios';
import ApiService from '../../../services/ApiService';
import "./chooseUser.css"
import { setUsersPayer } from '../../../reducers/reposReducers';





 
const ChooseUser = (props) => {
  const getSubaccountsURL = `${API_URL}GetSubaccounts`;
  const config = { headers: { Authorization: `Bearer ${localStorage.getItem('token')}` } };
  const apiService = ApiService.getInstance();
  const [res, setRes] = useState([]);
  const [resUser, setResUser] = useState([]);
  const [getResponse, setGetResponse] = useState(0);
  const [allert, setallert] = useState(false);
  const [userID, setUserID] = useState();
  const [userName, setUserName] = useState();
  const [selectUsersId, setSelectUsersId] = useState();
  const [selectPayerId, setSelectPayerId] = useState();
  const [isRelatedPerson, setIsReletedPerson] = useState(false);
  const history = useHistory();
  let userIDhistory =  localStorage.getItem('usersID')
  const usersPayerDispatch = useDispatch();
    function goToSummary(){
   
   
      props.next()
    }
  
    function tegetRelationsUsersst() {
      setallert(true);
      axios
          .get(getSubaccountsURL, config)
          .then((response) => {
          
              props.setOption(response.data)
         
              setRes(response.data);
            
              setGetResponse(response.data.length);
              setTimeout(() => {
                  setallert(false);
              }, 800);
          })
          .catch(function (error) {
              if (error.response.status == 401) {
                  history.push('/Error_sesja_wygasla');
                  setallert(false);
              }
          });
          localStorage.removeItem('selectedPayers');
          localStorage.removeItem('selectedPartipient');
          apiService.apiGet('UserGet', (response) => {  
            
            if (response.success) {
             
              
              // if(isAdult){
                usersPayerDispatch(setUsersPayer(response.data));
                setResUser(response.data)
                localStorage.setItem('users', JSON.stringify(response.data));
                localStorage.setItem('usersID', response.data.usersID);
                localStorage.setItem('participantUsersID', response.data.usersID);
                setUserID(response.data.usersID)
                
                if(localStorage.getItem('participantUsersID') != ""){
                  setSelectUsersId(localStorage.getItem('participantUsersID'))
                }else{
   
                  localStorage.setItem('userName',response.data.firstName +" "+ response.data.lastName)
                
                  setSelectUsersId(response.data.usersID)}
                
                // localStorage.setItem('usersID',response.data.usersID)
                setUserName(response.data.firstName +" "+ response.data.lastName)
                
                localStorage.setItem('payerName',response.data.firstName +" "+ response.data.lastName)
              // }                else{
              //      history.push('/Pulpit');
              //   }
            } else {
                
            }
        });
  }
  useEffect(()=>{
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
        'event' : 'checkout',
        'step' : `Uczestnik`
    });
    tegetRelationsUsersst();   
  },[])
 
  function checkIsConectedPerson (id, isReleted, fullUser){
    
    if(isReleted == undefined){
      setIsReletedPerson(false)
    }else{
    setIsReletedPerson(isReleted)
    }
    setSelectUsersId(id);

    localStorage.setItem('selectedPartipient', JSON.stringify(fullUser));
  }
  function checkIsPayerPerson (id, isReleted, fullUser){
    
  
    setSelectPayerId(id);

    localStorage.setItem('selectedPayers', JSON.stringify(fullUser));
  }
    return <> 
    <div className='wrraper'>

 <div className='chooseUser_selectUSer'>
 <CustomTittle>Wybierz uczestnika kursu</CustomTittle>
   <p className='forWho'>Dla kogo kupujesz kurs?</p>
    {selectUsersId == userID?
    <ChooseUserOption option={resUser} userName={userName} isChekcked={true} idUsers={userID} onCheck={checkIsConectedPerson} label="Dla siebie"/>:<ChooseUserOption  idUsers={userID} isChekcked={false} option={resUser} userName={userName} onCheck={checkIsConectedPerson}  label="Dla siebie"/>}
    <ChooseUserSelect setPayer={checkIsPayerPerson}  isAdult={resUser.adult} isRelatedPerson={selectUsersId != userID} selectUsersId={selectUsersId} selectPayerId={selectPayerId} onCheck={checkIsConectedPerson} showModal={props.showModal} option={props.option} label="Dla osoby powiązanej"/>
    <CustomButtons clickFunction={goToSummary} classButton="solid" size="big">PRZEJDŹ DALEJ</CustomButtons>

 </div>
  <div className='columDetials'>

   <div className='columDetials_wrapper'>
                <CustomTittle>Szczegóły  zamówienia  </CustomTittle>
                <CourseDetail wrapNavigator={props.wrapNavigator}  setWrapNavigator={props.setWrapNavigator} setHeader={(e)=>{props.setHeader(e)}} header={props.header}></CourseDetail>
    </div>
  </div>
  </div>
    </>;
    }

export default ChooseUser;
